import { render, staticRenderFns } from "./ViewPADirectory.vue?vue&type=template&id=57770a62&scoped=true"
import script from "./ViewPADirectory.vue?vue&type=script&lang=js"
export * from "./ViewPADirectory.vue?vue&type=script&lang=js"
import style0 from "./ViewPADirectory.vue?vue&type=style&index=0&id=57770a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57770a62",
  null
  
)

export default component.exports